export default __webpack_public_path__ + "static/media/75.cf55a85e.jpg";